<div class="container">
    <!-- <button mat-raised-button color="primary" class="button" (click)="getAudioUrls()">
    Click me to download the Audio
  </button> -->
    <!-- <div style="width: inherit; height: inherit"> -->
    <div class="header" *ngIf="showAudioButtons">
        <button mat-button class="output-header" disabled (click)="showOriginalAudio()">
      Original
    </button>

        <button mat-button class="output-header" disabled (click)="showStitchedAudio()">
      Stitched
    </button>
    </div>
    <div class="output" *ngIf="outputReady">
        <audio controls="controls" preload="metadata" id="audio_player" *ngIf="showOriginal">
      <source [src]="originalAudioUrl" type="audio/x-wav" />
    </audio>
        <audio controls="controls" preload="metadata" id="audio_player_2" *ngIf="showStitched">
      <source [src]="stitchedAudioUrl" type="audio/x-wav" />
    </audio>
    </div>
    <div class="footer" *ngIf="showAudioButtons">
        <button mat-raised-button class="output-header" (click)="openUrl(originalAudioUrl)">
      <div><i class="fas fa-download"></i> Original</div>
    </button>

        <button mat-raised-button class="output-header" (click)="openUrl(stitchedAudioUrl)">
      <div><i class="fas fa-download"></i> Stitched</div>
    </button>
    </div>
    <!-- </div> -->
</div>
